<template>

  <HomepageWideLayout>
    <ProgressDots v-if="user_type != 'admin'" step="1" :steps="steps" />
    <b-container class="invite-content text-center">
      <h1>Accept Invite</h1>

      <h2 v-if="user_type == 'admin'">You have been invited<br>to administer a Brandly team</h2>
      <h2 v-else>You have been invited<br>to order business cards</h2>

      <b-row>
        <b-col md="3"/>
        <b-col md="6">
          <div class="signup-fieldset" v-if="inviteLoaded">
            <b-form-input v-model="name" placeholder="Your name" required="required" type="text" class="signup-account-input" autofocus="autofocus" name="name"></b-form-input>
            <b-form-input v-if="email" :value="email" lass="signup-account-input" name="email" disabled></b-form-input>
            <b-form-input v-model="password" placeholder="Password" required="required" type="password" class="signup-account-input" autofocus="autofocus" name="password"></b-form-input>
            <b-btn variant="default" class="wide-btn" size="lg" @click="submit">Accept Invite</b-btn>
            <div v-if="error" class="error">{{error}}</div>
          </div>
        </b-col>
      </b-row>

      <p class="fineprint">See a mistake or don't want to accept the invite? Just close the window.
      <br>
      Questions? <a href="/contact" target="_blank">Contact us</a>
      </p>
    </b-container>

  </HomepageWideLayout>

</template>

<style scoped lang="scss">
.invite-content {
  min-height: calc(100vh - 323px);
}

.signup-fieldset {
  display: block;
  margin: 0 auto;
  min-width: 250px;
  max-width: 400px;
  padding-top: 3em;
}



.signup-account-input,
.signup-account-submit  {
  width: 100%;
  font-weight: 400;
  border-radius: 0;
  padding: 10px 20px;
  margin: 10px auto;
}

.wide-btn {
  width: 100%;
}

.fineprint {
  font-size: smaller;
  margin: 3em 0 1em 0;
}

.error {
  color: red;
  text-align: left;
  font-size: smaller;
}
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
export default {
  props: ['uid', 'token', 'user_type'],
  computed: {
    ...mapGetters(['inviteLoaded', 'inviteUser', 'isAdmin', 'requireProductTemplateChoice']),
    steps() {
      return this.requireProductTemplateChoice
        ? ['Accept invitation', 'Enter details', 'Choose Design', 'Place order']
        : ['Accept invitation', 'Enter details', 'Place order'];
    }
  },
  data() {
    return {
      name: '',
      email: '',
      password: '',
      error: ''
    }
  },
  watch: {
    inviteUser(val) {
      if (!val) return;
      if (!this.name) this.name = ((val.first_name||'') + ' ' + (val.last_name||'')).trim();
      this.email = val.email;
    }
  },
  async mounted() {
    this.loadInviteData({uid: this.uid, token: this.token});
  },
  methods: {
    ...mapActions(['acceptInvite', 'loadInviteData']),
    async submit() {
      try {
        await this.acceptInvite({uid: this.uid, token: this.token, name: this.name, password: this.password});
        if (!this.loginError) {
          // All good -- users continue to setup, admins to dashboard
          this.$router.push(this.isAdmin ? '/dashboard' : '/setup');
        }
      } catch({error, active}) {
        if (active) {
          // TODO Go to login page
          console.log("Go to login page");
        }
        this.error = error;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/Invite.vue